export const API_URL = {
    URL: process.env.NODE_ENV === 'development' ? 'http://192.168.0.200:8888/hubex/sim-proj/api/' : 'https://hubex.com.br/sim-proj/api/'
}